import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ClassFilter, ProgramsFilter } from 'features/filters';
import {
  AssignmentActionNotificationPopup,
  AssignmentPanel,
} from 'features/assignment-panel';
import { useUserProgramsData } from 'widgets/programs/model';
import { useClasses } from 'entities/classes';
import { useAppSelector } from 'shared/lib/redux';
import { ContentWrapper, SeeAllHeader, SeeAllPage } from 'shared/ui/layout';

export const StreamPageLayout = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  const { classes } = useClasses();
  const { userProgramsData } = useUserProgramsData();
  const {
    isAssignmentPanelOpened,
    isAssignmentActionNotificationActive,
    editingAssignment,
  } = useAppSelector((state) => state.assignmentPanel);

  const classesCount = classes?.length ?? 0;

  const shouldShowClassFilter = classesCount > 1;
  const shouldShowProgramsFilter = userProgramsData.length > 1;

  return (
    <SeeAllPage>
      <SeeAllHeader title={t('Stream')}>
        <div className="d-block flex-fill d-sm-flex d-lg-block align-items-center justify-content-end">
          {shouldShowClassFilter && <ClassFilter />}
          {shouldShowProgramsFilter && <ProgramsFilter />}
        </div>
      </SeeAllHeader>
      <div className="col-md-12 col-lg-9 rhythm-mt-3">
        <div className="row rhythm-row">
          <ContentWrapper>{children}</ContentWrapper>
        </div>
      </div>
      {isAssignmentPanelOpened && editingAssignment && <AssignmentPanel />}
      {isAssignmentActionNotificationActive && (
        <AssignmentActionNotificationPopup />
      )}
    </SeeAllPage>
  );
};
